"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendRequest2 = exports.sendRequest = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _isomorphicFetch = require("isomorphic-fetch");

var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);

var _url = require("url");

var _url2 = _interopRequireDefault(_url);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function grabToken() {
  try {
    if (typeof localStorage !== "undefined") {
      return localStorage.getItem("soc-token");
    }
  } catch (e) {
    console.error("grabToken error", e);
  }

  return null;
} // TODO: This function has changed but several redux thunks are calling it based on the previous
// signature. This means that none of the redux thunks using this sendRequest will work
// See here for original: https://github.com/SchoolOfCode/soc-front-end/blob/master/src/libs/utils/requests.js#L7


var sendRequest = exports.sendRequest = function sendRequest(_ref) {
  var destination = _ref.destination,
      _ref$options = _ref.options,
      options = _ref$options === undefined ? {} : _ref$options,
      query = _ref.query,
      token = _ref.token;

  var headers = _extends({
    "Content-Type": "application/json"
  }, options.headers); // if token explicitly passed or found


  if (token) {
    headers = _extends({}, headers, {
      Authorization: "Bearer " + token
    });
  } else {
    var t = grabToken();

    if (t) {
      headers = _extends({}, headers, {
        Authorization: "Bearer " + t
      });
    }
  }

  var fetchOptions = _extends({}, options, {
    headers: headers
  });

  var sendTo = query ? "" + destination + _url2.default.format({
    query: query
  }) : destination;
  return (0, _isomorphicFetch2.default)(sendTo, fetchOptions).then(function (response) {
    if (response.status >= 400) {
      return response.json().then(function (err) {
        console.error("err", err);
        throw err;
      });
    } // TODO: maybe not json here, but let resolve() sort it


    return response.json();
  });
};

var sendRequest2 = exports.sendRequest2 = function sendRequest2(_ref2) {
  var destination = _ref2.destination,
      _ref2$options = _ref2.options,
      options = _ref2$options === undefined ? {} : _ref2$options,
      query = _ref2.query;
  var token = localStorage.getItem("soc-token");
  var headers = {};

  if (options.headers) {
    headers = _extends({}, options.headers);
  }

  headers = _extends({}, headers, {
    Authorization: "Bearer " + token
  });

  var fetchOptions = _extends({}, options, {
    headers: headers
  });

  var sendTo = query ? "" + destination + _url2.default.format({
    query: query
  }) : destination;
  return (0, _isomorphicFetch2.default)(sendTo, fetchOptions).then(function (response) {
    return response;
  }).then(function (response) {
    if (response.status >= 400) {
      return response.json().then(function (err) {
        console.error("err", err);
        throw err;
      });
    } // TODO: maybe not json here, but let resolve() sort it


    return response.json();
  });
};